export default __webpack_public_path__ + "img/25.asset.9f3d3ea5.jpeg";